import React from 'react';
import '../styles/AboutUs.css';
import WhyChooseUs from '../components/WhyChooseUs';
import Partnerships from '../components/Partnerships';
import LetsCollaborate from '../components/LetsCollaborate';
import Leadership from '../components/Leadership';
import Vision from '../components/Vision';

const AboutUs = () => {
  return (
    <div className="about-content">
      <h1>About Us</h1>
      <section className="about-description">
        <p>
        Infinipoint Technologies specializes in delivering advanced solutions through partnerships with global leaders in engineering, simulation, and electronic design. By combining strategic expertise with world-class tools, we empower businesses and academic institutions to drive innovation, enhance performance, and achieve measurable success. Our forward-thinking approach ensures impactful, future-ready solutions tailored to meet diverse industry needs.
        </p>
      </section>
      <Vision/>
      <WhyChooseUs/>
      <Partnerships/>
      <LetsCollaborate/>
      <Leadership/>
    </div>
  );
};

export default AboutUs;

